const IOS_DEVICE_PATTERN = /iPad|iPhone|iPod/;
const NON_SAFARI_IOS_BROWSER_PATTERN = /CriOS|FxiOS|EdgiOS|OPiOS/;

export function isIosSafariBrowser(userAgent: string): boolean {
  const isIosDevice = IOS_DEVICE_PATTERN.test(userAgent);
  const isAnotherBrowserOnIos = NON_SAFARI_IOS_BROWSER_PATTERN.test(userAgent);
  return isIosDevice && isAnotherBrowserOnIos === false;
}
